import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

interface CreateEstimateFormData {
  netValue: string;
  datedOn: string;
  status: string;
}

interface CreateEstimateModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (formData: CreateEstimateFormData) => void;
  loading?: boolean; // <-- new
}

const getToday = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const CreateEstimateModal: React.FC<CreateEstimateModalProps> = ({
  show,
  onHide,
  onSubmit,
  loading = false,  // default to false if not provided
}) => {
  // Local form states
  const [netValue, setNetValue] = useState('0.00');
  const [datedOn, setDatedOn] = useState<string>(getToday());
  const [status, setStatus] = useState('Draft'); // or "Open", "Approved"

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ netValue, datedOn, status });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Create New Estimate</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Net Value */}
          <Form.Group className="mb-3">
            <Form.Label>Net Value</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={netValue}
              onChange={(e) => setNetValue(e.target.value)}
              placeholder="1000.00"
            />
          </Form.Group>

          {/* Dated On */}
          <Form.Group className="mb-3">
            <Form.Label>Dated On (YYYY-MM-DD)</Form.Label>
            <Form.Control
              type="date"
              value={datedOn}
              onChange={(e) => setDatedOn(e.target.value)}
            />
          </Form.Group>

          {/* Status (Dropdown) */}
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              aria-label="Estimate Status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="Draft">Draft</option>
              <option value="Open">Open</option>
              <option value="Approved">Approved</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Creating...
              </>
            ) : (
              'Create'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateEstimateModal;
